import { strategies } from '../data/mockData';

function StrategiesPage() {
  return (
    <section className="panel-section">
      <div className="table-card">
        <div className="card-header">
          <div>
            <p className="eyebrow">Section 3</p>
            <h4>Strategy Management</h4>
            <p>Placeholder controls for user-wise enablement and global pause handling.</p>
          </div>
          <button type="button" className="ghost-button compact">
            Pause Strategy Globally
          </button>
        </div>
        <div className="strategy-grid">
          {strategies.map((strategy) => (
            <article key={strategy.id} className="strategy-card">
              <div className="strategy-topline">
                <h5>{strategy.name}</h5>
                <span className={`status-pill ${strategy.status.toLowerCase()}`}>
                  {strategy.status}
                </span>
              </div>
              <p>{strategy.assignedUsers} users assigned</p>
              <p>Mode: {strategy.mode}</p>
              <div className="action-group">
                <button type="button" className="primary-button compact">
                  Enable / Disable
                </button>
                <button type="button" className="ghost-button compact">
                  Pause Global
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StrategiesPage;
